import { Outlet } from "react-router";

import { LogoWithTitle } from "@/site/ui/logo-with-title";

// Keep legal content readable and visually connected to the public brand.
export default function LegalLayout() {
  return (
    <div className="mx-auto flex w-[calc(100%-3rem)] max-w-3xl flex-col pb-20 sm:pb-30">
      <header className="flex h-16 items-center justify-end sm:mb-24 sm:pr-2">
        <LogoWithTitle linkTo="/" />
      </header>
      <Outlet />
    </div>
  );
}
